var _linearGradient, _linearGradient2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 68.49,
    x2: 424.45,
    y1: 68.49,
    y2: 424.45
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#298ffe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0435da"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 436.15,
    x2: 105.32,
    xlinkHref: "#linear-gradient",
    y1: 436.15,
    y2: 105.32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#linear-gradient)",
    r: 256
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#linear-gradient-2)",
    r: 220
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "m226.42 294.94c7.6-11.14 15-21.94 22.33-32.72q33.9-49.62 67.85-99.22c6.71-9.77 15.67-11.19 25.37-4.56 3.6 2.46 7.28 4.8 10.84 7.31 8.92 6.29 10.73 15.52 4.57 24.57q-36.24 53.22-72.62 106.35-17.64 25.83-35.19 51.71c-6.85 10.14-15.73 12.12-25.82 5q-32.4-22.84-64.51-46.11c-9.58-6.93-10.74-15.88-3.83-25.5 2.71-3.76 5.33-7.58 8.13-11.27 5.75-7.6 14.41-9.48 22.38-4.25 9.33 6.14 18.27 12.85 27.38 19.32z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.04e8417654c33049191f1284b2100a69.svg";
export { ForwardRef as ReactComponent };